import { useState } from 'react';
import RolePrivileges from './RolePrivileges';
import _ from 'lodash';
import { Grid, TextInput, Tabs, GridContainerFullHeight } from '@ts/storybook';
import { useRouterContext } from '@utils/context/RouterContext';
import DataGridParameterSettings from '../Parameters/DataGridParameterSettings';
import { IForm } from '@ts/ui-models';

const RoleForm = (props: IForm) => {
  const { values, mode, onCallbackChange } = props;
  const [state, setState] = useState({ activeTab: 'information' });
  const { transferPropsRoute } = useRouterContext();

  let left, left1;

  const _roleId = (left = transferPropsRoute.params.id) != null ? left : 'new';

  const tabs = [
    { label: 'Information', value: 'information' },
    {
      label: 'Settings',
      value: 'settings',
      disabled: (left1 = _roleId === 'new') != null ? left1 : false ? true : undefined,
    },
    { label: 'Privileges', value: 'privileges' },
  ];

  const _handleTabChange = (_event, tab) => {
    return setState({ activeTab: tab });
  };

  //#region Render
  const _renderInformation = () => {
    const isViewMode = mode === 'view';

    return (
      <GridContainerFullHeight>
        <TextInput isReadOnly={isViewMode} label="Name" value={values.name} onChangeValue={onCallbackChange('name')} />

        <TextInput
          isReadOnly={isViewMode}
          label="Description"
          value={values.description}
          onChangeValue={onCallbackChange('description')}
        />
        <TextInput
          multiline
          isReadOnly={isViewMode}
          label="Notes"
          value={values.notes}
          onChangeValue={onCallbackChange('notes')}
        />
      </GridContainerFullHeight>
    );
  };

  const _renderSettings = () => {
    return <DataGridParameterSettings {...props} type="role" />;
  };

  const _renderPrivileges = () => {
    return <RolePrivileges {...props} />;
  };

  const _renderContents = () => {
    const contents = (() => {
      switch (state.activeTab) {
        case 'information':
          return _renderInformation();
        case 'settings':
          return _renderSettings();
        case 'privileges':
          return _renderPrivileges();
      }
    })();

    return contents;
  };
  //#endregion

  return (
    <Tabs id={'role-page'} tabs={tabs} value={state.activeTab} onChange={_handleTabChange}>
      {_renderContents()}
    </Tabs>
  );
};

export default RoleForm;
